import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  // function submitTest(){
    
  // }
  
  return (
    <>
      <button title="Instructions" onClick={handleClickOpen} style={{cursor:'pointer', textAlign:'center', paddingTop: '2px', fontSize:15, fontWeight:'bold', backgroundColor:'#555555', width: 23, height: 23, borderRadius: '50%', border: '1px solid #555555', color: '#FFFFFF'}} >i</button>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'98vh'}}>
          <Grid item   md={12} xs={12} className="test-instructions" >
								<div className="btmbdrgry"><h3>Instructions</h3></div>
								<p>
									<ol>
										<li>The clock has been set at server and count down timer at the top right corner of the screen will display left out time to closure from where you can monitor time you have to complete the exam.</li>
										<li>Click answer option buttons to select your answer.</li>
										<li>To change an answer, simply click the desired option button.</li>
										<li>Click on RESET button to deselect a chosen answer.</li>
										<li>Click on SAVE & NEXT to save the answer before moving to the next question. The next question will automatically be displayed.</li>
										<li>Click on SKIP to move to the next question without saving the current question.</li>
										<li>Click on MARK FOR REVIEW to review your answer at later stage.</li>
										<li>Make sure you click on SAVE & NEXT button everytime you want to save your answer.</li>
										<li>To go to a question, click on the question number on the right side of the screen.</li>
										<li>The color coded diagram on the right side of the screen shows the status of the questions												
												<div>
													<div><div className="qbg-not-visited-ins" style={{background:"url('/not-visited.png')"}} >2</div> you have not visited question no 2. </div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/not-answered.png')"}} >3</div> you have not answered question no 3.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/answered.png')"}} >4</div> you have answered question no 4.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/review.png')"}} >5</div> you have marked the question no. 5 for review.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/answered-review.png')"}}  >6</div> you have answered & marked for review of question no. 6</div>
												</div>												
										</li>								
										<li className="clr">Candidate will be allowed to Shuffle between sections and questions anytime during the examination as per their convenience.</li>
										<li>Candidate can change their response of attempted answers anytime during the examination slot time by clicking another answer which candidates wants to change.</li>
										<li>All the answered questions(saved or marked) will be considered for calculating the final score.</li>
										<li className="redboldtxt" >Do Not PRESS any keyboard key once the exam is started.This will LOCK your exam. You can connect with the exam invigilator to unlock and continue giving the exam.</li>
										<li className="redboldtxt" >Do Not CLICK on the SUBMIT Button unless you have completed the exam.In case you click SUBMIT button, you will not be permitted to continue.</li>
									</ol>
								</p>
							</Grid>


          </DialogContent>
      </Dialog>
    </>
  );
}
